import type { SocialIconsNames } from './type';

//https://jira.tennisi.it/browse/SITE-632

export const TENNISI_SOCIALS: SocialIconsNames = {
  telegram: 'https://t.me/Tennisiofficial',
  instagram: 'https://www.instagram.com/tennisi.official',
  youtube: 'https://www.youtube.com/channel/UCCKmtHm-XNsHUW0Y5SjK4lg',
  twitter: 'https://twitter.com/tennisibet',
};
